<app-hero-medico-dispensario/>
<app-decreto/>
<app-info/>
<app-footer-persona/>
